var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-15"},[_c('div',{staticClass:"tixstock-trending-categories-heading"}),_c('div',{staticClass:"tixstock-tags-skeleton"},_vm._l((12),function(index){return _c('div',{key:index,staticClass:"tixstock-tag-skeleton"})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }